import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "../../mixin/store/api/fetchModel";
import changeOrPushModel from "../../mixin/store/api/changeOrPushModel";
import changeModel from "@/mixin/store/api/changeModel";
import pushModel from "@/mixin/store/api/pushModel";
import deleteModel from "@/mixin/store/api/deleteModel";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchEmployees(context, page) {
            return fetchModels(context, 'people?exists[employeePositions]=true&order[id]=desc', page, 'updateEmployees');
        },
        fetchEmployeesAll(context) {
            return fetchModels(context, 'people?exists[employeePositions]=true', null, 'updateEmployees');
        },
        fetchEmployee(context, id) {
            return fetchModel(context, 'people', id, 'updateEmployee');
        },
        fetchEmployeesCount(context, companyId) {
            return fetchModels(context, 'people?exists[employeePositions]=true&company.id=' + companyId, null, 'updateEmployeesCount');
        },
        pushPersonEmployee(context, data) {
            data.employeePosition = context.getters.getEmployeePosition(data.employeePosition)['@id']

            // return changeModel(context, 'users/' + , data)

            if (data.id) {
                return changeModel(context, 'people/' + data.id + '/employee', data)
            }

            return pushModel(context, 'people/employee', data)
        },
        pushEmployee(context, data) {
            data.employeePosition = context.getters.getEmployeePosition(data.employeePosition)['@id']

            return changeOrPushModel(context, 'people', data)
        },
        putEmployee(context, data) {
            axios.interceptors.request.use((config) => {
                config.headers['Content-Type'] = 'application/ld+json'

                return config
            })

            return changeModel(context, 'people/' + data.id, data)
        },
        deleteEmployee(context, id) {
            return deleteModel(context, 'people', id);
        },
        pushEmployeeImage(context, data){
            return pushModel(context, 'pictures', data, 'updateEmployeeImage')
        },
        searchEmployee(context, searchItem) {
            let url = "people?exists[employeePositions]=true&page=" + searchItem.page;
            let isSearch = false;

            if (searchItem.employeeGivenName) {
                url = url + '&givenName=' + searchItem.employeeGivenName + '&'
                isSearch = true;
            }

            if (searchItem.employeeFamilyName) {
                url = url + '&familyName=' + searchItem.employeeFamilyName
                isSearch = true;
            }

            if (searchItem.employeeTelephone) {
                url = url + '&telephone=' + searchItem.employeeTelephone
                isSearch = true;
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateEmployees', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchEmployeeKpi(context) {
            let url = "people/kpis"

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data,
                        totalItems: 0
                    }

                    context.commit('updateEmployees', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchEmployeeSalaries(context) {
            return fetchModels(context, 'people/salary?exists[employeeInformation]=true', null, 'updateEmployeeSalaries')
        },
        fetchEmployeeSalary(context, id) {
            return fetchModels(context, 'people/salary?exists[employeeInformation]=true&id=' + id, null, 'updateEmployeeSalaries')
        },
        pushSalary(context, data) {
            return pushModel(context, 'people/pay_salary', data)
        }
    },
    mutations: {
        updateEmployees(state, data) {
            state.employees = data
        },
        updateEmployeesCount(state, data) {
            state.employeesCount = data
        },
        updateEmployee(state, data) {
            state.employee = data
        },
        updateEmployeeImage(state, data) {
            state.employeeImage = data
        },
        updateEmployeeSalaries(state, data) {
            for (let employee of data.models) {
                employee.payedAmount = ''

                if (employee.employeeSalaries.length) {
                    employee.salaryOf = employee.employeeSalaries[0].salaryOf.slice(0, 7)
                } else {
                    employee.salaryOf = new Date().toISOString().slice(0,7)
                }

                if (employee.employeeSalaries.length) {
                    for (let empSal of employee.employeeSalaries) {
                        empSal.salaryOf = empSal.salaryOf.slice(0, 7)
                    }
                }
            }

            state.employeeSalaries = data
        }
    },
    state: {
        employees: {
            models: [],
            totalItems: 0,
        },
        employeesCount: {
            models: [],
            totalItems: 0,
        },
        employee: {

        },
        employeeSalaries: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getEmployee(state) {
            return state.employee
        },
        getEmployees(state) {
            return state.employees.models
        },
        getEmployeesCount(state) {
            return state.employeesCount.totalItems
        },
        getEmployeesTotalCount(state) {
            return state.employees.totalItems
        },
        getEmployeeSalaries(state) {
            return state.employeeSalaries.models
        },
        getEmployeeSalariesTotalCount(state) {
            return state.employeeSalaries.totalItems
        }
    },
}
